import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b1e449e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__simple-datepicker" }
const _hoisted_2 = { class: "datepicker-label" }
const _hoisted_3 = ["name", "value"]

import { computed, onBeforeUnmount, onMounted, ref, toRefs, watch } from 'vue';

  import flatpickr from "flatpickr";
  import { BaseOptions } from 'flatpickr/dist/types/options';
  import { Instance } from 'flatpickr/dist/types/instance';
  import { German } from "flatpickr/dist/l10n/de.js";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'simple-datepicker',
  props: {
    name: {
      // name attribute
      type: String,
      default: null,
    },
    modelValue: {
      // v-model
      type: [Date, String],
      default: () => new Date()
    },
    future: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: Date,
      default: null,
    },
    skipDefaultValue: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:model-value"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const emit = __emit;
  
  const { disabled } = toRefs(props);
  const picker = ref<Instance | null>(null);
  const target = ref<HTMLInputElement | null>(null);

  onMounted(() => {
    resetPicker();

    const handleDateChange = (selectedDates: Date[], dateStr: string, instance: Instance) => {
      emit("update:model-value", dateStr);
    };

    const options: Partial<BaseOptions> = {
      locale: German,
      altFormat: "d.m.Y",
      altInput: true,
      defaultDate: props.skipDefaultValue
        ? undefined
        : props.modelValue || props.minDate || new Date(),
      onValueUpdate: handleDateChange,
      onReady: handleDateChange,
      onChange: handleDateChange,
    };

    // Future dates allowed?
    if (!props.future) {
      options.maxDate = new Date();
    }

    if (props.minDate) {
      options.minDate = props.minDate;
    }

    if (target.value) {
      picker.value = flatpickr(target.value, options);
    }
  });

  onBeforeUnmount(() => {
    resetPicker();
  });
  
  const resetPicker = () => {
    if (picker.value) {
      picker.value.destroy();
      picker.value = null;
    }
  };
  const updatePickerDisabled = () => {
    if (!picker.value) return;

    if (props.disabled)
      picker.value._input.setAttribute("disabled", "disabled");
    else picker.value._input.removeAttribute("disabled");
  };

  watch([disabled, picker], () => {
    updatePickerDisabled();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createElementVNode("input", {
        placeholder: "Datum wählen",
        ref_key: "target",
        ref: target,
        name: __props.name,
        value: __props.modelValue
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})